<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc" role="doc-toc">
<h1 class="SOM_titre" epub:type="title">Contents</h1>
<div class="SOM_pre"><a href="#/pre1">Foreword by Daniel Hill</a></div>
<div class="SOM_pre"><a href="#/pre2">Introduction: Everyone Has a Story</a></div>
<div class="SOM_chap"><a href="#/chap1"><span class="tabulation"><b>1</b> A Past I Could Not Touch</span></a></div>
<div class="SOM_chap"><span href="#/chap2" title="Link target outside of Sample"><span class="tabulation"><b>2</b> A History Few Wanted to Understand</span></span></div>
<div class="SOM_chap"><span href="#/chap3" title="Link target outside of Sample"><span class="tabulation"><b>3</b> God Is Justice</span></span></div>
<div class="SOM_chap"><span href="#/chap4" title="Link target outside of Sample"><span class="tabulation"><b>4</b> Confronting Buried History</span></span></div>
<div class="SOM_chap"><span href="#/chap5" title="Link target outside of Sample"><span class="tabulation"><b>5</b> Unpacking Biases</span></span></div>
<div class="SOM_chap"><span href="#/chap6" title="Link target outside of Sample"><span class="tabulation"><b>6</b> Engaging Differences</span></span></div>
<div class="SOM_chap"><span href="#/chap7" title="Link target outside of Sample"><span class="tabulation"><b>7</b> Engage Your Community</span></span></div>
<div class="SOM_chap"><span href="#/chap8" title="Link target outside of Sample"><span class="tabulation"><b>8</b> Practice Proximity</span></span></div>
<div class="SOM_chap"><span href="#/chap9" title="Link target outside of Sample"><span class="tabulation"><b>9</b> Sit at Another's Table</span></span></div>
<div class="SOM_chap"><span href="#/chap10" title="Link target outside of Sample"><b>10</b> Break the Silence</span></div>
<div class="SOM_appen"><span href="#/appen1" title="Link target outside of Sample">Conclusion: Be the Solution</span></div>
<div class="SOM_appen"><span href="#/appen2" title="Link target outside of Sample">Afterword</span></div>
<div class="SOM_appen"><span href="#/appen3" title="Link target outside of Sample">Acknowledgments</span></div>
<div class="SOM_appen"><span href="#/appen4" title="Link target outside of Sample">Appendix: Further Educational Material</span></div>
<div class="SOM_appen"><span href="#/appen5" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/appen8" title="Link target outside of Sample">Praise for <i>All God's Children</i></span></div>
<div class="SOM_appen"><span href="#/appen9" title="Link target outside of Sample">About the Author</span></div>
<div class="SOM_appen"><span href="#/appen6" title="Link target outside of Sample">Also by Terence Lester</span></div>
<div class="SOM_appen"><span href="#/appen7" title="Link target outside of Sample">About Love Beyond Walls</span></div>
<div class="SOM_pdf"><span href="#/fin_acheve" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?4ff3dcf2